import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { NotificationsSettingsClient } from './-components/NotificationsSettingsClient';

export const Route = createFileRoute('/_authed/settings/notifications/')({
  component: SettingsNotificationsPage,
});

function SettingsNotificationsPage() {
  const query = useQuery({
    ...identityKeys.notificationPreferences(),
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        title="Notifications"
        message="Could not load notification preferences."
      />
    );
  }
  if (query.isLoading) return null;
  return <NotificationsSettingsClient />;
}
